import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { useIsMyMsg, useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

export interface MsgMediaCallNetworkErrorContentProps {
  message: Msg;
}

export const MsgMediaCallNetworkErrorContent = memo(function MsgMediaCallNetworkErrorContent({
  message,
}: MsgMediaCallNetworkErrorContentProps) {
  const { t } = useTranslation();
  const { user } = useUserInfo(message.owner_id);
  const isMe = useIsMyMsg(message);

  return (
    <>
      {!isMe && <MsgUserText userName={user?.name || ''} userId={user?.user_id} />}
      <Text as="span" color="fg.muted" px="0.5">
        {isMe ? t('chat.youNetworkError') : t('chat.networkError')}
      </Text>
    </>
  );
});
